module.exports = __webpack_public_path__ + "static/media/notFoundCharacterBertoni.aea10388.svg";